declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function pushAuditStart(cta_location: "header" | "footer" | "hero" | "inline") {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "audit_start", cta_location });
}

export function pushBookCallClick(audit_score: number | null, audit_has_gaps: boolean) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "book_call_click", audit_score, audit_has_gaps });
}
